<template>
  <div>
    <card class="mt-3">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <p-button
            type="primary"
            style="margin-left:20px;"
            class="float-right"
            title="Print the Recognition Form"
            @click="printTicket"
          >
            Print Ticket
          </p-button>
          <p-button
            type="primary"
            style="margin-left:20px;"
            class="float-right"
            title="Print the Ticket Form"
            v-if="displayScouterKey"
            @click="printRecognition"
          >
            Print Recognition Form
          </p-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <fg-input>
            <label for="vision"><strong>My Personal Vision of Success</strong></label>
            <textarea
              class="form-control"
              :disabled="readonly"
              @blur="onVisionBlur"
              placeholder="I see skies of blue.."
              rows="10"
              v-model="ticket.Vision"
              style="max-height:300px;"
            />
          </fg-input>
        </div>
      </div>
    </card>
    <card class="mt-3">
      <div class="row mt-3">
        <div class="col-lg-6 col-md-6 col-sm-6 text-danger">
          Ticket Counselor
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div>{{ supportInfo.CounselorName }}</div>
          <div>{{ supportInfo.CounselorPhoneNumber }}</div>
          <div>{{ supportInfo.CounselorEmailAddress }}</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-6 col-md-6 col-sm-6 text-danger">
          Course Director
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
          <div>{{ supportInfo.CourseDirectorName }}</div>
          <div>{{ supportInfo.CourseDirectorPhoneNumber }}</div>
          <div>{{ supportInfo.CourseDirectorEmailAddress }}</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-12 col-md-12 col-sm-12">
          You have 18 months to work your ticket. If you have a question or concern about any part of your ticket, please contact your Ticket Counselor as soon as possible to discuss the issue.
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-6 col-md-6 col-sm-6">
          Your ticket completion deadline is:
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 deadline">
          {{ formatDate(supportInfo.TicketDeadline) }}
        </div>
      </div>
      <print-ticket
        v-if="printItem"
        v-show="showPrint"
        :ticket="ticket"
        :support-info="supportInfo"
      />
      <report-application-for-recognition
        v-if="displayScouterKey"
        :key="displayScouterKey"
        v-show="showPrint"
        :scouter-key="displayScouterKey"
      />
    </card>
  </div>
</template>

<script>
import ticketGoalApi from '@/services/api/ticket'
import formatter from '@/services/formatter.js'
import printTicket from '@/components/tickets/ticket-print.vue'
import ReportApplicationForRecognition from '@/components/reports/report-application-for-recognition.vue'

export default {
  name: 'TicketVision',
  components: {
    printTicket,
    ReportApplicationForRecognition
  },
  props: {
    ticket: {
      type: Object,
      default: function () {
        return {}
      }
    },
    statuses: {
      type: Object,
      default: function () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: null
    },
    displayScouterKey: {
      type: String,
      default: null
    },
    supportInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      callingPage: null,
      originalVision: null,
      loading: true,
      errormessage: null,
      showPrint: false,
      printItem: '',
      printOptions: {},
      isActive: true,
      ticketPrintOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/ticket.css'
        ]
      },
      recognitionPrintOptions: {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/recognition.css'
        ]
      }
    }
  },
  updated: function () {
    this.$nextTick(function () {
      if (this.printItem) {
        this.$htmlToPaper(this.printItem, this.printOptions)
      }
      this.printItem = null
    })
  },
  methods: {
    formatDate: function (dt) {
      return formatter.formatAsDate(dt)
    },
    printTicket: function () {
      this.printOptions = this.ticketPrintOptions
      this.printItem = 'printpage'
    },
    printRecognition: function () {
      this.printOptions = this.recognitionPrintOptions
      this.printItem = 'app4recognition'
    },
    onVisionBlur: function () {
      if (this.originalVision !== this.ticket.Vision) {
        ticketGoalApi
          .updateTicket(this.$root.scouterKey, this.ticket)
          .then(x => {
            this.ticket = x.Ticket
            this.supportInfo = x.SupportInfo
            this.originalVision = this.ticket.Vision
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error retrieving your data.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label {
  margin-bottom: 0;
  margin-top: 0.5rem;
  padding-left: 0.3rem;
}
.deadline {
  font-weight: bold;
  color: red;
}
</style>
